var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66732 10C7.12755 10 7.50065 10.3731 7.50065 10.8333V12.9167C7.50065 14.9877 9.17958 16.6667 11.2507 16.6667C13.3217 16.6667 15.0007 14.9877 15.0007 12.9167V11.6667C15.0007 11.2064 15.3737 10.8333 15.834 10.8333C16.2942 10.8333 16.6673 11.2064 16.6673 11.6667V12.9167C16.6673 15.9082 14.2422 18.3333 11.2507 18.3333C8.25911 18.3333 5.83398 15.9082 5.83398 12.9167V10.8333C5.83398 10.3731 6.20708 10 6.66732 10Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88824 3.33366C3.58141 3.33366 3.33268 3.58239 3.33268 3.88921V6.66699C3.33268 8.50794 4.82507 10.0003 6.66602 10.0003C8.50696 10.0003 9.99935 8.50794 9.99935 6.66699V3.88921C9.99935 3.58239 9.75062 3.33366 9.44379 3.33366H9.16601C8.70578 3.33366 8.33268 2.96056 8.33268 2.50033C8.33268 2.04009 8.70578 1.66699 9.16601 1.66699H9.44379C10.6711 1.66699 11.666 2.66192 11.666 3.88921V6.66699C11.666 9.42842 9.42744 11.667 6.66602 11.667C3.90459 11.667 1.66602 9.42842 1.66602 6.66699V3.88921C1.66602 2.66192 2.66094 1.66699 3.88824 1.66699H4.16602C4.62625 1.66699 4.99935 2.04009 4.99935 2.50033C4.99935 2.96056 4.62625 3.33366 4.16602 3.33366H3.88824Z",
    fill: "#ffbb00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.834 10.8333C16.2942 10.8333 16.6673 10.4602 16.6673 10C16.6673 9.53976 16.2942 9.16667 15.834 9.16667C15.3737 9.16667 15.0007 9.53976 15.0007 10C15.0007 10.4602 15.3737 10.8333 15.834 10.8333ZM15.834 12.5C17.2147 12.5 18.334 11.3807 18.334 10C18.334 8.61929 17.2147 7.5 15.834 7.5C14.4533 7.5 13.334 8.61929 13.334 10C13.334 11.3807 14.4533 12.5 15.834 12.5Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.f64b38ac209c14c295ec7c0d006b415c.svg";
export { ForwardRef as ReactComponent };